import { useLang } from "../context/LanguageContext";
import { useAIAssistant } from "../context/AIAssistantContext";

export const AIAssistantModal = () => {
  const { t } = useLang();
  const { open, closeAssistant } = useAIAssistant();

  return (
    <div
      data-testid="ai-modal-root"
      aria-hidden={!open}
      className={`fixed inset-0 z-[60] transition-opacity duration-300 ${
        open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Backdrop */}
      <div
        onClick={closeAssistant}
        className="absolute inset-0 bg-black/70 backdrop-blur-md"
      />

      {/* Panel */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label={t.modal.title}
        className={`absolute inset-x-2 bottom-2 sm:inset-auto sm:bottom-24 sm:right-6 sm:w-[440px] lg:w-[480px] h-[min(86vh,760px)] sm:h-[680px] max-h-[92vh] flex flex-col fk-glass rounded-2xl fk-glow border border-[#FF5A00]/25 overflow-hidden transform transition-all duration-300 ${
          open ? "translate-y-0 scale-100" : "translate-y-6 scale-95"
        }`}
        data-testid="ai-modal-panel"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/5 bg-[#0c0c0f]/80">
          <div className="flex items-center gap-3">
            <span className="relative inline-flex items-center justify-center w-9 h-9 rounded-full bg-gradient-to-br from-[#FF5A00] to-[#c74400] text-white">
              <i className="fa-solid fa-wand-magic-sparkles text-sm" />
              <span className="absolute inset-0 rounded-full fk-pulse-glow" />
            </span>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-white truncate">
                {t.modal.title}
              </div>
              <div className="text-[11px] text-zinc-500 truncate">
                <span className="inline-flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                  {t.modal.live}
                </span>
              </div>
            </div>
          </div>
          <button
            onClick={closeAssistant}
            data-testid="ai-modal-close"
            aria-label={t.modal.close}
            className="w-9 h-9 rounded-full border border-white/10 text-zinc-300 hover:text-white hover:border-[#FF5A00]/40 inline-flex items-center justify-center transition-colors"
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>

        {/* Subtitle */}
        <div className="px-4 py-2.5 text-xs text-zinc-400 border-b border-white/5 bg-[#0c0c0f]/50">
          {t.modal.subtitle}
        </div>

        {/* Widget body */}
        <div
          className="flex-1 overflow-hidden bg-[#09090b]"
          data-testid="ai-modal-body"
        >
          <div
            id="VG_OVERLAY_CONTAINER"
            data-testid="vg-container"
            className="w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};
